module.exports = __webpack_public_path__ + "img/logo-icon.b93981b6.png";